import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// 加载插件
const Plugins = require.context("./plugins", true, /\.js$/);
Plugins.keys().map(Plugins);

// 加载组件
const Components = require.context("./components", true, /\.vue$/);
Components.keys()
  .map(Components)
  .forEach((item: any) => {
    if (item.default.name) Vue.component(item.default.name, item.default);
  });

// 加载样式
import "@/assets/styles/flex.scss";
import "@/assets/styles/main.scss";
import "@wangeditor/editor/dist/css/style.css";

// 全局声明版本配置，以便页面直接使用
import {
  platformType,
  sysPlatformOs,
  sysPlatformType,
} from "./config/edition.config";

Vue.prototype.$platformType = platformType;
Vue.prototype.$sysPlatformType = sysPlatformType;
Vue.prototype.$sysPlatformOs = sysPlatformOs;

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
